<template>
  <transition
    enter-active-class="transform transition ease-in-out duration-500  "
    enter-class="translate-y-full"
    enter-to-class="translate-y-0"
    leave-active-class="transform transition ease-in-out duration-500 "
    leave-class="translate-y-0"
    leave-to-class="translate-y-full"
  >
    <div
      v-if="!isOnline"
      :class="wrapperClass"
      class="glass-carbon absolute inset-0 z-50 px-6 py-6"
    >
      <div class="flex h-full items-center justify-center">
        <div class="space-y-6">
          <div class="flex justify-center">
            <div v-html="offline"></div>
          </div>
          <h2 class="text-center text-3xl font-bold text-gray-300">
            Você está offline
          </h2>
          <p class="text-center text-lg text-gray-400">
            Não foi possivel conectar com o servidor.
            <br />
            <strong>
              Seus investimentos estão sendo processados normalmente em nossos
              servidores.</strong
            >
          </p>
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
import EventBus from "@/app/shared/utils/event_bus";
import { offline } from "../../../assets/icons/isometric";
import Ping from "ping.js";

export default {
  data() {
    return {
      offline: offline,
      isOnline: navigator.onLine || false,
      events: ["online", "offline", "load"],
      url: this.pingUrl || "https://google.com",
    };
  },

  props: {
    onlineClass: {
      type: String,
      required: false,
      default: "",
    },
    offlineClass: {
      type: String,
      required: false,
      default: "",
    },
    pingUrl: {
      type: String,
      required: false,
      default: "https://google.com",
    },
  },

  mounted() {
    let vm = this;
    this.events.forEach((event) =>
      window.addEventListener(event, function (e) {
        vm.check(event);
      })
    );
  },

  unmounted() {
    let vm = this;
    this.events.forEach((event) =>
      window.removeEventListener(event, vm.check())
    );
  },

  computed: {
    wrapperClass() {
      if (this.isOnline) {
        return typeof this.onlineClass === "string" ? this.onlineClass : "";
      } else {
        return typeof this.offlineClass === "string" ? this.offlineClass : "";
      }
    },
  },

  methods: {
    async check(event) {
      const p = new Ping();
      try {
        const ping = await p.ping(this.url);
        // console.log("ping", event);
        if (ping || navigator.onLine) {
          this.isOnline = true;
          // console.log("check", this.isOnline);

          EventBus.$emit("TESTE", this.isOnline);
        }
      } catch (error) {
        if (error || !navigator.onLine) {
          this.isOnline = false;
          // console.log("check", this.isOnline);
          EventBus.$emit("TESTE", this.isOnline);
        }
      }
    },
  },
};
</script>
